import { DialogueRewardLevel, ABILITY_COLORS } from '../../../api/models';
// Colors for reward levels
const REWARD_LEVEL_COLORS = {
    [DialogueRewardLevel.None]: '#666666', // Gray
    [DialogueRewardLevel.Low]: '#F44336', // Red
    [DialogueRewardLevel.Medium]: '#FFC107', // Yellow
    [DialogueRewardLevel.High]: '#4CAF50' // Green
};
// Colors for links - each link pair gets a unique color
const LINK_COLORS = [
    { primary: '#2196F3', secondary: '#1976D2' }, // Blue
    { primary: '#E91E63', secondary: '#C2185B' }, // Pink
    { primary: '#9C27B0', secondary: '#7B1FA2' }, // Purple
    { primary: '#673AB7', secondary: '#512DA8' }, // Deep Purple
    { primary: '#3F51B5', secondary: '#303F9F' }, // Indigo
    { primary: '#00BCD4', secondary: '#0097A7' }, // Cyan
    { primary: '#009688', secondary: '#00695C' }, // Teal
    { primary: '#8BC34A', secondary: '#689F38' }, // Light Green
    { primary: '#CDDC39', secondary: '#AFB42B' }, // Lime
    { primary: '#FFC107', secondary: '#F57C00' }, // Amber
    { primary: '#FF9800', secondary: '#E65100' }, // Orange
    { primary: '#795548', secondary: '#5D4037' }, // Brown
];
// Function to get the color of a link
export const getLinkColor = (linkId) => {
    const hash = linkId.split('').reduce((a, b) => {
        a = ((a << 5) - a) + b.charCodeAt(0);
        return a & a;
    }, 0);
    const index = Math.abs(hash) % LINK_COLORS.length;
    return LINK_COLORS[index];
};
// Function to get the color of a characteristic
export const getCharacteristicColor = (ability) => {
    return ABILITY_COLORS[ability];
};
// Function to get the color of a reward level
export const getRewardLevelColor = (rewardLevel) => {
    return REWARD_LEVEL_COLORS[rewardLevel];
};
// Returns the edit-panel header color based on the editing state
export const getEditHeaderColor = (state) => {
    if (!state)
        return '#3a6ea5';
    if (state.type === 'dialogue') {
        return '#ffa726'; // primary NPC color
    }
    // response
    const resp = state.nodeData;
    if (resp.linkedToDialogueId) {
        return getLinkColor(resp.linkedToDialogueId).primary;
    }
    if (resp.requiredCharacteristic) {
        return getCharacteristicColor(resp.requiredCharacteristic);
    }
    return '#4caf50';
};
